import { render } from "./Leaderboards.vue?vue&type=template&id=ee320b7c"
import script from "./Leaderboards.vue?vue&type=script&lang=js"
export * from "./Leaderboards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__